import axios from "axios";
import { config } from "../../Utils/helpers";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listFranchises = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) {
      dispatch({ type: "START_LOADING" });
    }
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FRANCHISE_LIST_REQUEST" });


      const { data } = await axios.post(
        `${BASE_URL}/franchise/list`,
        filterData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FRANCHISE_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FRANCHISE_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FRANCHISE_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch franchises");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// View franchise by ID
export const viewFranchise = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FRANCHISE_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/franchise/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FRANCHISE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FRANCHISE_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FRANCHISE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch franchise");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const sendFranchiseOtp = (data) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "SEND_FRANCHISE_OTP_REQUEST" });

      // Prepare payload based on send_on key
      let payload = {};
      if (data.send_on === "number") {
        payload = {
          send_on: "number",
          primary_country_code: data.primary_country_code,
          primary_contact_number: data.primary_contact_number,
        };
      } else if (data.send_on === "email") {
        payload = {
          send_on: "email",
          primary_email: data.primary_email,
        };
      } else {
        throw new Error("Invalid send_on value");
      }

      const { data: responseData } = await axios.post(
        `${BASE_URL}/franchise/send-otp`,
        payload,
        config
      );

      if (responseData.statusCode === 200) {
        dispatch({ type: "SEND_FRANCHISE_OTP_SUCCESS", payload: responseData });
        // toast.success("OTP sent successfully");
        return responseData;
      } else {
        dispatch({ type: "SEND_FRANCHISE_OTP_FAILED", payload: responseData });
        // toast.error(responseData.message || "Failed to send OTP");
        return responseData;
      }
    } catch (error) {
      dispatch({
        type: "SEND_FRANCHISE_OTP_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || error.message || "Failed to send OTP");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// Verify OTP API for franchise
export const verifyFranchiseOtp = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VERIFY_FRANCHISE_OTP_REQUEST" });

      // Send the full payload object directly without nesting
      const { data } = await axios.post(
        `${BASE_URL}/franchise/verify-otp`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VERIFY_FRANCHISE_OTP_SUCCESS", payload: data });
        // toast.success("OTP verified successfully");
        return data;
      } else {
        dispatch({ type: "VERIFY_FRANCHISE_OTP_FAILED", payload: data });
        // toast.error(data.message || "Failed to verify OTP");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VERIFY_FRANCHISE_OTP_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to verify OTP");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// Add franchise API
// Accepts FormData or JSON payload depending on file upload requirement
export const addFranchise = (franchiseData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_FRANCHISE_REQUEST" });
      const configData = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/franchise/add`,
        franchiseData,
        configData
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_FRANCHISE_SUCCESS", payload: data });
        // toast.success("Franchise added successfully");
        return data;
      } else {
        dispatch({ type: "ADD_FRANCHISE_FAILED", payload: data });
        // toast.error(data.message || "Failed to add franchise");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_FRANCHISE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to add franchise");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const listFranchiseBuilders = (page = 1, limit = 20, franchise_id = null) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FRANCHISE_BUILDER_LIST_REQUEST" });

      if (!franchise_id) {
        throw new Error("franchise_id is required");
      }

      const payload = { page, limit };

      const url = `${BASE_URL}/franchise/builder-list/${franchise_id}`;

      const { data } = await axios.post(url, payload, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FRANCHISE_BUILDER_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FRANCHISE_BUILDER_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FRANCHISE_BUILDER_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || error.message || "Failed to fetch builder list");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



// New API: Assign builder to franchise (POST)
export const assignBuilderToFranchise = (assignData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ASSIGN_BUILDER_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/assign-builder`,
        assignData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ASSIGN_BUILDER_SUCCESS", payload: data });
        // toast.success("Builder assigned successfully");
        return data;
      } else {
        dispatch({ type: "ASSIGN_BUILDER_FAILED", payload: data });
        // toast.error(data.message || "Failed to assign builder");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ASSIGN_BUILDER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to assign builder");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const assignProjectToFranchise = (assignData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ASSIGN_PROJECT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/assign-builder-project`,
        assignData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ASSIGN_BUILDER_SUCCESS", payload: data });
        // toast.success("Builder assigned successfully");
        return data;
      } else {
        dispatch({ type: "ASSIGN_BUILDER_FAILED", payload: data });
        // toast.error(data.message || "Failed to assign builder");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ASSIGN_BUILDER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to assign builder");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// New API: Revoke builder from franchise (POST)
export const revokeBuilderFromFranchise = (revokeData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REVOKE_BUILDER_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/revoke-builder`,
        revokeData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REVOKE_BUILDER_SUCCESS", payload: data });
        // toast.success("Builder revoked successfully");
        return data;
      } else {
        dispatch({ type: "REVOKE_BUILDER_FAILED", payload: data });
        // toast.error(data.message || "Failed to revoke builder");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "REVOKE_BUILDER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to revoke builder");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



// Fetch builders by franchise using new API route with query params
export const getBuildersByFranchise = (franchise_id, filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) {
      dispatch({ type: "START_LOADING" });
    }
    try {
      dispatch({ type: "GET_BUILDERS_BY_FRANCHISE_REQUEST" });

      const url = `${BASE_URL}/franchise/builders-by-franchise/${franchise_id}`;

      const { data } = await axios.post(url, filterData);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_BUILDERS_BY_FRANCHISE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_BUILDERS_BY_FRANCHISE_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_BUILDERS_BY_FRANCHISE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch builders");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const getProjectList = (projectData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) {
      dispatch({ type: "START_LOADING" });
    }
    try {
      dispatch({ type: "GET_PROJECTS_LIST_REQUEST" });

      const config = { headers: { "Content-Type": "application/json" } };
      const { data } = await axios.post(`${BASE_URL}/franchise/project-list`, projectData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECTS_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_PROJECTS_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECTS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};


export const viewExcel = (project_id, category_id, project_type) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_EXCEL_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/project-catalogue-list`,
        { project_id, category_id, project_type }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_EXCEL_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_EXCEL_FAIL", payload: data });
        toast.error("Something Goes Wrong!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_EXCEL_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error fetching Excel data");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const assignCatalogue = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ASSIGN_CATALOGUE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/assign-builder-catalogue-unit`,
        payload
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ASSIGN_CATALOGUE_SUCCESS", payload: data });
        // toast.success("Catalogue assigned successfully!");
        return data;
      } else {
        dispatch({ type: "ASSIGN_CATALOGUE_FAIL", payload: data });
        // toast.error("Something went wrong while assigning catalogue");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ASSIGN_CATALOGUE_FAIL",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to assign catalogue");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listFranchiseCatalogues = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FRANCHISE_CATALOGUE_LIST_REQUEST" });

      if (!payload.franchise_id) {
        throw new Error("franchise_id is required");
      }

      // Prepare payload
      const requestPayload = {
        page: payload.page,
        limit: payload.limit,
        franchise_id: payload.franchise_id,
      };

      const { data } = await axios.post(
        `${BASE_URL}/franchise/assigned-catalogue-all`,
        requestPayload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FRANCHISE_CATALOGUE_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FRANCHISE_CATALOGUE_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FRANCHISE_CATALOGUE_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || error.message || "Failed to fetch catalogues");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const revokeCatalogueAssignment = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REVOKE_CATALOGUE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/revoke-catalogue`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REVOKE_CATALOGUE_SUCCESS", payload: data });
        // toast.success("Catalogue assignment revoked successfully");
        return data;
      } else {
        dispatch({ type: "REVOKE_CATALOGUE_FAILED", payload: data });
        // toast.error(data.message || "Failed to revoke catalogue assignment");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "REVOKE_CATALOGUE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to revoke catalogue assignment");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const revokeBuilderProjectAssignment = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REVOKE_BUILDER_PROJECT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/revoke-builder-project`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REVOKE_BUILDER_PROJECT_SUCCESS", payload: data });
        // toast.success("Builder project assignment revoked successfully");
        return data;
      } else {
        dispatch({ type: "REVOKE_BUILDER_PROJECT_FAILED", payload: data });
        // toast.error(data.message || "Failed to revoke builder project assignment");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "REVOKE_BUILDER_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to revoke builder project assignment");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateFranchiseAccountStatus = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_ACCOUNT_STATUS_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/franchise/account-status-update`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_ACCOUNT_STATUS_SUCCESS", payload: data });
        // toast.success("Franchise account status updated successfully");
        return data;
      } else {
        dispatch({ type: "UPDATE_ACCOUNT_STATUS_FAILED", payload: data });
        // toast.error(data.message || "Failed to update account status");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_ACCOUNT_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update account status");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
